const TONE = {
  CHECK_IN: "text-teal-300", UNDO_CHECK_IN: "text-amber-300", GUEST_DELETED: "text-rose-300",
  IMPORT: "text-orange-300", EXPORT: "text-slate-300", GUEST_ADDED: "text-orange-300", GUEST_EDITED: "text-slate-300",
};

export function AttendanceLog({ logs }) {
  return (
    <div className="rounded-2xl border border-slate-800 bg-[#131D33] p-5" data-testid="attendance-log">
      <div className="text-xs tracking-[0.3em] uppercase text-orange-400 font-bold mb-3">Activity</div>
      {!logs.length && <div className="text-sm text-slate-500">No activity yet.</div>}
      <ul className="space-y-2 max-h-[420px] overflow-y-auto pr-1">
        {logs.map((l) => (
          <li key={l.id} className="text-xs border-b border-slate-800/60 pb-2" data-testid="attendance-log-item">
            <div className="flex justify-between gap-2">
              <span className={`font-bold ${TONE[l.action] || "text-slate-300"}`}>{l.action.replace(/_/g, " ")}</span>
              <span className="text-slate-500">{new Date(l.at).toLocaleTimeString([], { hour: "numeric", minute: "2-digit" })}</span>
            </div>
            <div className="text-slate-300">{l.guest_name ? `${l.guest_name} (${l.guest_id})` : l.note}</div>
            <div className="text-slate-500">by {l.by_name}</div>
          </li>
        ))}
      </ul>
    </div>
  );
}
